import { BrowserRouter, Routes, Route } from "react-router-dom";

import axios from "axios";
import { QueryClientProvider, QueryClient } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { Toaster } from "react-hot-toast";
import {
  UnauthenticatedTemplate,
  MsalAuthenticationTemplate,
} from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";

import { getEnv } from "./environment";

import Header from "./components/generic/Header";
import Footer from "./components/generic/Footer";

import ReferenceTables from "./components/Reference/ReferenceTables";
import CarrierForm from "./components/Carrier/CarrierForm";
import SiteMap from "./components/ContextFinalBuild/SiteMap/SiteMap";
import Audit from "./components/Audit/Audit";

import AccessDenied from "./Generic/AccessDenied";
import ProtectedRoutes from "./Generic/ProtectedRoutes";

import "./App.css";
import "./components/Content.css";
import { PreferenceProvider } from "./components/SiteStructures&Circuits/PreferenceProvider";
import { HTML5Backend } from "react-dnd-html5-backend";
import { DndProvider } from "react-dnd";
import SSCIndex from "./components/ContextFinalBuild/SSCIndex";
import { RoleProvider } from "./components/ContextFinalBuild/Providers/RoleProvider";
import { SSCProvider } from "./components/ContextFinalBuild/Providers/SSCProvider";
import { ModalProvider } from "./components/ContextFinalBuild/Providers/ModalProvider";

const env = getEnv();
axios.defaults.baseURL = env.url;

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <RoleProvider>
          <ModalProvider>
            <PreferenceProvider>
              <MsalAuthenticationTemplate
                interactionType={InteractionType.Redirect}
              >
                <Header />
                <DndProvider backend={HTML5Backend}>
                  <div className="app-page-content">
                    <Routes>
                      <Route
                        path="/*"
                        element={
                          <SSCProvider>
                            <SSCIndex />
                          </SSCProvider>
                        }
                      />
                      {/* <Route
                        path="/*"
                        element={
                          <StructureProvider>
                            <SiteCircuitManagement />
                          </StructureProvider>
                        }
                      /> */}
                      <Route
                        path="/carrier/:paramCarrierName"
                        element={<CarrierForm />}
                      />
                      <Route path="/carrier/*" element={<CarrierForm />} />
                      <Route
                        path="/sitemap"
                        element={
                          <SSCProvider>
                            <SiteMap />
                          </SSCProvider>
                        }
                      />
                      <Route path="/audit" element={<Audit />} />
                      <Route
                        path="/reference/*"
                        element={
                          <ProtectedRoutes role="cvp.write">
                            <ReferenceTables />
                          </ProtectedRoutes>
                        }
                      />
                    </Routes>
                    <UnauthenticatedTemplate>
                      <Routes>
                        <Route path="*" element={<AccessDenied />} />
                      </Routes>
                    </UnauthenticatedTemplate>
                  </div>
                </DndProvider>
                <Footer />
                <Toaster
                  position="bottom-right"
                  reverseOrder={false}
                  toastOptions={{
                    style: {
                      marginBottom: "25px",
                    },
                  }}
                />
              </MsalAuthenticationTemplate>
            </PreferenceProvider>
          </ModalProvider>
        </RoleProvider>
      </BrowserRouter>
      <ReactQueryDevtools initialIsOpen={false} position="bottom-left" />
    </QueryClientProvider>
  );
}

export default App;

//Trigger
